"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const TvContenidosAudiovisuales = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        size.width = width;
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
    }
    if (height && height !== "auto") {
        size.height = height;
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 17.067 20.065" }, size, { style: Object.assign({}, insetPosition), fill: fill, "aria-label": "", "aria-hidden": "true", role: "presentation" }),
            react_1.default.createElement("path", { d: "M14.085 14.131l-11.1-.007a2.968 2.968 0 01-2.237-.8A3.01 3.01 0 010 11.142v-5.2a2.678 2.678 0 012.982-2.957l11.1.007a2.679 2.679 0 012.985 2.958v5.2a3.019 3.019 0 01-.746 2.178 2.976 2.976 0 01-2.237.8zM2.982 3.956a2.09 2.09 0 00-1.542.5 2.068 2.068 0 00-.469 1.486v5.2a1.753 1.753 0 002.011 2.011l11.1.007a1.753 1.753 0 002.011-2.011V5.95a2.058 2.058 0 00-.471-1.489 2.086 2.086 0 00-1.542-.5l-11.1-.007zm7.679 12.093L6.4 16.042a.486.486 0 110-.971l4.262.007a.486.486 0 110 .971z" }))));
};
exports.default = TvContenidosAudiovisuales;
//# sourceMappingURL=index.js.map